import React from 'react';
import {ScrollView, Text} from 'react-native';
import {View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {LoadingView} from '/component/base/LoadingView';
import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import {styles} from './LoadingView.style';

storiesOf('base', module).add('Loading View', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>LoadingView</Heading>
        <Spacer size={16} />
        <Text>
          This is the <Code>{'LoadingView'}</Code> component. We use it to
          display the loading screen if the application is not yet ready for
          display (waiting for the end of the initialization of some providers).
        </Text>
        <Spacer size={20} />
        <View style={styles.wrapper}>
          <LoadingView />
        </View>
      </FlexView>
    </Spacing>
  </ScrollView>
));
